export default __webpack_public_path__ + "cfde389f5c8424dfcd2f23ee63d79cac.png";